module.exports = __webpack_public_path__ + "static/media/router.b7c1543b.svg";